class StripeErrorHandling {
    constructor(data) {
        this.code = data.json.code;
        this.doc_url = data.json.doc_url;
        this.message = data.json.msg;
        this.translated_message = data.translated_message;
        this.param = data.json.param;
        this.request_log_url = data.json.request_log_url;
        this.type = data.json.type;
    }

    show_error(){
        if(this.param != '')
            this.build_error_obj_by_type();

        show_snackbar({
            message: get_language_translation('LANG_MSG_THERE_WAS_AN_ERROR_ADDING_YOUR_PAYMENT_METHOD')+ ': ' + this.translated_message,
            type: 'danger',
            timer: 4000,
            autoClose: true,
            show_close: true
        });
    }

    build_error_obj_by_type(){
        if(this.type == 'card_error')
            return this.get_card_errors();
        // else if(this.type == 'acct_number')
        //     return this;
    }

    get_card_errors(){
        var msg_obj = {};
        if(this.param == 'number')
            msg_obj = this.build_number_error_obj();
        else if(this.param == 'exp_month' || this.param == 'exp_year'){
            msg_obj = this.build_expiration_error_obj();
        }
        else if(this.param == 'cvv2' || this.param == 'cvc'){
            msg_obj = this.build_cvv2_error_obj();
        }

        show_error_msg(msg_obj);
    }

    build_number_error_obj(std = true){
        let msg_obj = {};

        if(std){
            msg_obj = {
                target: '#cc_num',
                msg: this.translated_message
            }
        }

        return msg_obj;
    }

    build_cvv2_error_obj(std = true){
        let msg_obj = {};

        if(std){
            msg_obj = {
                target: '#cc_cvv2',
                msg: this.translated_message
            }
        }

        return msg_obj;
    }

    build_expiration_error_obj(std = true){
        let msg_obj = {};

        if(std){
            msg_obj = {
                target: '#am-exp-date-cont',
                msg: this.translated_message,
                custom_section: { section_type: 'card_expiration_date', subsection: this.param == '#exp_month' ? '#exp_month' : '#exp_year'}
            };
        }

        return msg_obj;
    }
}
